/**
 * @fileoverview Redirects Users to formstack feedback form on the url provided through site-feedback.
 * @author akothapall@gannett.com (Amarnath Kothapalli)
 *
 */

define('third-party-apis/formstack',[
        'jquery',
        'underscore',
        'utils',
        'state',
        'third-party-apis/base-third-party-api'
    ],
    function(
        $,
        _,
        Utils,
        StateManager,
        BaseThirdPartyApi
    ) {

        "use strict";

        var Formstack = BaseThirdPartyApi.extend({
            initialize: function() {
                var siteconfig = this.getApiSiteConfig('FORMSTACK');
                if (siteconfig.ENABLED) {
                    BaseThirdPartyApi.prototype.initialize.call(this);
                }
            },

            redirectToFeedbackForm: function(e) {
                e.preventDefault();
                var pageInfo = StateManager.getActivePageInfo(),
                    params = {
                        abTestVariant : Utils.getNested(pageInfo, 'user', 'abTest', 'userVariant', 'id') || "null",
                        platform : "cp",
                        url : encodeURIComponent(window.location.href) || '',
                        cta : (["insider", "xtras"].indexOf(window.location.pathname.split('/')[1]) > -1) ? window.location.pathname.split('/')[1] + '-' + e.target.dataset.cta : e.target.dataset.cta,
                        market: Utils.getNested(window.site_vars, 'site_key')
                    },
                    feedbackURL = Utils.getNested(window.site_vars, 'base_url'),
                    queryString = Object.keys(params).map(function(key) {
                        return key + '=' + params[key];
                    }).join('&');
                window.location.href = 'https://cm.' + feedbackURL + '/site-feedback/?' + queryString;
            }
        });

        return new Formstack();

    });
